import { win } from '@rei/browser-shim';
import tracking from '../../legacy/components/tracking';
import createApp from './main';
import { getClientPageData } from '../../utils/dom';
import './course-location-search';

import '../../../style/pages/course/entry.scss';

const initalizeMetrics = () => {
  const pageName = `course details_${win.analyticsData.courseTitle}_${win.analyticsData.courseId}`;

  tracking.init({ pageName });
  tracking.view(win.analyticsData);
};

const { pageData: props } = getClientPageData();

const { app } = createApp(props);
app.mount('#app');
initalizeMetrics();
